import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const VALUES = [
  { value: 2, label: '2' },
  { value: 4, label: '4' },
  { value: 8, label: '8' },
  { value: 16, label: '16' },
  { value: 32, label: '32' },
  { value: 64, label: '64' },
];
const MAX = VALUES[VALUES.length - 1]!.value;

export function KnockoutMaxPartiesInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  const mode = useWatch({ name: 'mode', control });

  return (
    <FormRow>
      <FormLabel>
        Макс.{' '}
        {mode === 'Team' || mode === 'PrivateTeam' || mode === 'TwoOnTwo' ? 'команд' : 'участников'}
      </FormLabel>
      <FormInput>
        <Controller
          name="knockOutSettings.maxPartiesCount"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs
              tabs={VALUES}
              value={value ?? MAX}
              disabled={disabled}
              noTabMinWidth
              onChange={onChange}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
